import React, {Component} from "react";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {CustomInput, FormGroup} from "reactstrap";

class Checkbox extends Component {
    render() {
        return (
            <FormGroup>
                {this.props.isChecked && (
                    <FontAwesomeIcon
                        icon="check"
                        className="check-icon"
                        size="sm"
                        color="#59595B"
                        onClick={(e) => this.props.handleChange(e)}
          />
        )}
        <CustomInput
            type="checkbox"
            id={this.props.id}
            label={this.props.label}
            className="custom-checkbox-input"
            checked={this.props.isChecked}
            onChange={(e) => this.props.handleChange(e)}
        />
      </FormGroup>
    );
  }
}

export default Checkbox;



// WEBPACK FOOTER //
// ./src/common/Checkbox/Checkbox.js